// extracted by mini-css-extract-plugin
export var close = "cookie-module--close--80033";
export var got = "cookie-module--got--a6fc2";
export var mCookie = "cookie-module--m-cookie--ab627";
export var mCookieMain = "cookie-module--m-cookie-main--a0bbf";